import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Helmet } from "react-helmet";
import Header from '../../../components/default/header';
import GlobalSidebarMenu from '../../default/header/globalSidebarMenu';
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import { ShimmerPostList } from "react-shimmer-effects";
import { PrismTimeFormatter } from '../../default/utils/timeFormatter';
import { Link } from 'react-router-dom';
import { notificationDeleteAction, notificationStatusArchiveAction, notificationStatusUnArchiveAction } from '../../../store/actions/new/notificationAction';

const SingleNotificationData = ({ popupItemId = '', onClose, ntfStatus }) => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const status = ntfStatus || searchParams.get('status');
    const [notificationId, setNotificationId] = useState('');
    const dispatch = useDispatch();
    const { notificationAllData, unreadData, archiveData } = useSelector((store) => store.notificationData);
    const data = status === 'read'
        ? notificationAllData.data
        : status === 'new'
            ? unreadData.data
            : status === 'archive'
                ? archiveData.data
                : [];
    const [notification, setNotification] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [archiveStatus, setArchiveStatus] = useState(null);
    const navigate = useNavigate();

    // set notificationId
    useEffect(() => {
        // Set cardId first
        const newNotificationId = popupItemId || id;
        setNotificationId(newNotificationId);
    }, [popupItemId, id]);

    useEffect(() => {
        if (!notificationId) return;
        const existingNotification = data ? data.find((item) => String(item.id) === String(notificationId)) : null;
        if (!existingNotification) {
            const fetchNotification = async () => {
                try {
                    const response = await axios.get(`/notification/?id=${notificationId}`);
                    setNotification(response.data.data[0]);
                    setLoading(false);
                } catch (err) {
                    setError(err.message);
                    setLoading(false);
                }
            };

            fetchNotification();
        } else {
            setNotification(existingNotification);
            setLoading(false);
        }
    }, [notificationId, id]);

    const handleNotificationArchive = async (id) => {
        try {
            const response = await dispatch(notificationStatusArchiveAction(id));
            if (response.status === 200) {
                if (status === 'read') {
                    navigate('/notification');
                } else if (status === 'new') {
                    navigate('/notification/unread');
                } else {
                    navigate('/notification/archived');
                }

                onClose();

            } else {
                console.error('Failed to archive notification');
            }
        } catch (error) {
            console.error('Error archiving notification:', error);
        }
    };
    const handleNotificationUnArchive = async (id) => {
        try {
            const response = await dispatch(notificationStatusUnArchiveAction(id));
            if (response.status === 200) {
                if (status === 'read') {
                    navigate('/notification');
                } else if (status === 'new') {
                    navigate('/notification/unread');
                } else {
                    navigate('/notification/archived');
                }

                onClose();
            } else {
                console.error('Failed to archive notification');
            }
        } catch (error) {
            console.error('Error archiving notification:', error);
        }
    };
    const notificationDelete = async () => {
        try {
            const response = await dispatch(notificationDeleteAction(notificationId));
            if (response.status === 200) {
                onClose();
                if (status === 'read') {
                    navigate('/notification');
                } else if (status === 'new') {
                    navigate('/notification/unread');
                } else {
                    navigate('/notification/archived');
                }

            } else {
                console.error('Failed to delete notification');
            }
        } catch (error) {
            console.error('Error delete notification:', error);
        }
    };

    return (
        <>
            <div className="connection-header">
                {!loading && notification ? <h3>{notification.title}</h3> : ""}
                {!loading && notification && (
                    <div className="filter-wrapper">
                        {(notification.status === 'read' || notification.status === 'new') && (
                            <Link to="#" onClick={() => handleNotificationArchive(notificationId)} className="list-filter add-new-btn">
                                <i className="ri-inbox-archive-line"></i>
                                Archive
                            </Link>
                        )}
                        {notification.status === 'archive' && (
                            <Link to="#" onClick={() => handleNotificationUnArchive(notificationId)} className="list-filter add-new-btn">
                                <i className="ri-inbox-unarchive-line"></i>
                                <span>Unarchive</span>
                            </Link>
                        )}

                        <Link to="#" onClick={() => notificationDelete()} className="list-filter add-new-btn bg-delete">
                            <i className="ri-delete-bin-line"></i>
                            <span>Delete</span>
                        </Link>
                    </div>
                )}
            </div>

            {loading ? (
                <ShimmerPostList postStyle="STYLE_FOUR" col={1} row={1} gap={30} />
            ) : (
                notification && (
                    <div className="notification-detail-wrapper">
                        <div className="notification-detail">
                            <div className="notification-header">
                                <img src={notification.icon} alt="Notification Icon" />
                                <div className="notification-meta">
                                    <span className="date">
                                        {PrismTimeFormatter(notification.date)}
                                    </span>
                                </div>
                            </div>
                            <div className="notification-content">
                                <p>{notification.content}</p>
                            </div>
                        </div>
                    </div>
                )
            )}
            {!notification && !loading ? <div>No notification found.</div> : ""}

        </>
    );
};

export default SingleNotificationData;